<template>
  <div class="radio-group">
      <div class="radio-item" v-for="(item) in items" :key="item.id+'_'+item.value">
          <label :for="item.id">{{item.label}}</label>
          <input type="radio" :id="item.id" :name="name" :value="item.value" :checked="item.isActive ? 'checked': ''" @change="onChange">
          <span class="radiomark" @click="onChange({target: {value: item.value}})"></span>
      </div>
  </div>
</template>

<script>
export default {
  name: "RadioGroup",
  props: {
    items: {
      type: Array,
      required: true
    },
    name: {
      type: String,
      required: true
    }
  },
  methods: {
    onChange(e) {
	  this.$emit("input", e.target.value);
	  for (let i = 0; i < this.items.length; i++) {
		  if (this.items[i].value === e.target.value) {
			  this.items[i].isActive = true;
		  } else {
			  this.items[i].isActive = false;
		  }
	  }
	  this.$nextTick().then(() => {
		  this.$forceUpdate();
	  })
    }
  }
};
</script>

<style>
#app .radio-group{
    display: flex;
    flex-direction: row;
    margin-bottom: 12px;
    width: 100%;
    justify-content: flex-start;
    align-items: center;
    margin: 0.5em 0;
}

#app .radio-item {
  display: block;
  position: relative;
  padding-right: 30px;
  cursor: pointer;
  font-size: 1em;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  margin-right: 1em;
}

#app .radio-item:last-of-type{
    margin-right: 0;
}

#app .radio-item input {
  position: absolute;
  opacity: 0;
}

#app .radio-item input:focus + span {
  outline: 1px dotted #4a4f62;
  outline: -webkit-focus-ring-color auto 5px;
}


#app .radio-item .radiomark {
  position: absolute;
  top: 0;
  right: 0;
  height: 20px;
  width: 20px;
  background-color: #a1a7b9;
  border-radius: 50%;
  transition: all .3s ease-in-out;
}

#app .radio-item:hover input ~ .radiomark {
  background-color: #666F8A;
}

#app .radio-item input:checked ~ .radiomark {
  background-color: #3D8FFF;
}

#app .radiomark:after {
  content: "";
  position: absolute;
  display: none;
}

#app .radio-item input:checked ~ .radiomark:after {
  display: block;
}

#app .radio-item .radiomark:after {
  top: 6px;
  left: 6px;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: white;
}
</style>


// WEBPACK FOOTER //
// src/components/RadioGroup.vue